import { X } from 'lucide-react'

interface DemoRoleSelectionModalProps {
  isOpen: boolean
  onClose: () => void
  scenario: string
  onSelectRole: (role: string) => void
}

const DemoRoleSelectionModal = ({ isOpen, onClose, scenario, onSelectRole }: DemoRoleSelectionModalProps) => {
  if (!isOpen) return null

  const getRolesForScenario = () => {
    switch (scenario) {
      case 'student_report':
        return [
          {
            id: 'teacher',
            title: '教師',
            description: 'クラス担任として、学生のレポートを評価します'
          },
          {
            id: 'department_head',
            title: '学科主任',
            description: '学科全体の評価基準を確認・調整します'
          }
        ]
      case 'job_interview':
        return [
          {
            id: 'hr_manager',
            title: '人事担当者',
            description: '候補者の面接評価を行います'
          },
          {
            id: 'department_manager',
            title: '部門責任者',
            description: '技術面の評価を重点的に行います'
          }
        ]
      case 'contest_judging':
        return [
          {
            id: 'main_judge',
            title: '主任審査員',
            description: '全体的な評価基準を設定・管理します'
          },
          {
            id: 'expert_judge',
            title: '専門審査員',
            description: '専門的な観点から評価を行います'
          }
        ]
      default:
        return []
    }
  }

  const roles = getRolesForScenario()

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl max-w-md w-full">
        <div className="border-b border-gray-100 px-6 py-4 flex items-center justify-between">
          <h2 className="text-2xl font-bold text-gray-900">役割を選択</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        <div className="p-6">
          <p className="text-gray-600 mb-6">
            デモで体験する役割を選択してください
          </p>

          <div className="space-y-3">
            {roles.map((role) => (
              <button
                key={role.id}
                onClick={() => onSelectRole(role.id)}
                className="w-full text-left p-4 border-2 border-gray-200 rounded-lg hover:border-emerald-500 hover:bg-emerald-50 transition-colors"
              >
                <h3 className="font-semibold text-gray-900 mb-1">{role.title}</h3>
                <p className="text-sm text-gray-600">{role.description}</p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DemoRoleSelectionModal